export const chatChannelFilters = ['all', 'game', 'public', 'private', 'friends', 'clan', 'trade'] as const;

export type ChatChannelFilter = (typeof chatChannelFilters)[number];

export type ChatMessageChannel = Exclude<ChatChannelFilter, 'all'>;

export type ChatSurface = 'opaque' | 'transparent';

export const chatChannelLabels: Record<ChatChannelFilter, string> = {
  all: 'All',
  game: 'Game',
  public: 'Public',
  private: 'Private',
  friends: 'Channel',
  clan: 'Clan',
  trade: 'Trade',
};

export const chatTextColors = {
  opaque: {
    game: '#000000',
    public: '#0000ff',
    private: '#7f0000',
    friends: '#7f0000',
    clan: '#7f0000',
    trade: '#7f007f',
  },
  transparent: {
    game: '#ffff00',
    public: '#9090ff',
    private: '#bf2020',
    friends: '#ef5050',
    clan: '#7f0000',
    trade: '#df20ff',
  },
} as const satisfies Record<ChatSurface, Record<ChatMessageChannel, string>>;

export function chatTextColor(channel: ChatMessageChannel, surface: ChatSurface): string {
  return chatTextColors[surface][channel];
}

export function isChatChannel(id: string): id is ChatChannelFilter {
  switch (id) {
    case 'all':
    case 'game':
    case 'public':
    case 'private':
    case 'friends':
    case 'clan':
    case 'trade':
      return true;
    default:
      return false;
  }
}
